import ValueDeserializerInterface from "./ValueDeserializerInterface"
import GameDeserializer from "../GameDeserializer"
import { SerializedValueType } from "../../Model/Value/ValueInterface"
import SubtractionValue from "../../Model/Value/SubtractionValue"

export default class SubtractionValueDeserializer implements ValueDeserializerInterface {
  private gameDeserializer: GameDeserializer | undefined = undefined

  public supports(payload: SerializedValueType): boolean {
    return payload.type === "subtraction"
  }

  public deserialize(payload: SerializedValueType): SubtractionValue {
    if (this.gameDeserializer === undefined) {
      throw new Error("Unable to deserialize subtraction value")
    }

    return new SubtractionValue(
      this.gameDeserializer.deserializeValue(
        payload.payload.minuend as SerializedValueType,
      ),
      this.gameDeserializer.deserializeValue(
        payload.payload.subtrahend as SerializedValueType,
      ),
    )
  }

  public setSerializer(serializer: GameDeserializer): void {
    this.gameDeserializer = serializer
  }
}
